// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"deeec6c3","937":"9286d589"}[chunkId] + ".chunk.js";
};